/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Col_PtsInputs */



/**
* | output |
* | --- |
* | "RtP" |
*
* @param {User_Detail_Col_PtsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_col_pts = /** @type {((inputs?: User_Detail_Col_PtsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Col_PtsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "es") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("RtP")
	if (locale === "it") return /** @type {LocalizedString} */ ("RtP")
	return /** @type {LocalizedString} */ ("RtP")
});